import { Faqs } from 'data/mock-data';

const mock = () => ({
  data: {
    faqs: Faqs,
  },
});

export default mock;
